import type {
  ArrivalStop,
  DepartureStop,
  IntermediateStop,
  ItineraryStop,
  ItineraryStopWithArrivalTime,
  ItineraryStopWithDepartureTime,
  TransferStop
} from "./types";

export function isDepartureStop(
  stop: ItineraryStop | ItineraryStop[]
): stop is DepartureStop {
  return "departure_name" in stop && !("arrival_name" in stop);
}

export function isArrivalStop(
  stop: ItineraryStop | ItineraryStop[]
): stop is ArrivalStop {
  return !("departure_name" in stop) && "arrival_name" in stop;
}

export const isItineraryStopWithDepartureTime = (
  stop: ItineraryStop | ItineraryStop[]
): stop is ItineraryStopWithDepartureTime => {
  return "departure_time" in stop;
};

export const isItineraryStopWithArrivalTime = (
  stop: ItineraryStop | ItineraryStop[]
): stop is ItineraryStopWithArrivalTime => {
  return "arrival_time" in stop;
};

export function isTransferStop(
  stop: ItineraryStop | ItineraryStop[]
): stop is TransferStop {
  return "transfer" in stop && stop.transfer;
}

function isIntermediateStop(
  stop: ItineraryStop | ItineraryStop[]
): stop is IntermediateStop {
  return "departure_name" in stop && "arrival_name" in stop;
}

export function isIntermediateStopList(
  stops: ItineraryStop[]
): stops is IntermediateStop[] {
  return stops.every(isIntermediateStop);
}
